export const CLIENT_CASE_FOLDER_NAME = 'Documents Assembled without a Case';
